<script>
//import axios from 'axios';
export default {
  components: {},
  props: {
    objeto: {
      type: Object,
    },
  },
  data() {
    return {
      negocios:[]
    };
  },
  computed: {
    gerenteNegocio() {
      const usuario = JSON.parse(localStorage.getItem("user"));
      return this.permit == 7 ? this.negocios.find((item) => item.id_negocio == usuario.id_negocio) : this.negocios;
    },
  },
  mounted(){
      // axios.get('/negocios')
      // .then((res) =>{
      //     const {response="",data=[]} = res.data;
      //     if (response === true) {
      //         this.negocios = data;
      //         console.log(this.negocios)
      //         console.log(this.gerenteNegocio)
      //     }
      // })
      // .catch(err => {
      //     console.log(err);
      // })
  }
}
</script>

<template>
<div>
  <div class="row mt-4">
    <div class="col-sm-12 col-md-4">
      <b><label class="form-check-label">Nombre</label> </b>
      <div class="mb-4">
        <b-form-input
          v-model="objeto.nombre"
          id="nombre"
          placeholder="Nombre"
        ></b-form-input>
      </div>
    </div>
    <div class="col-sm-12 col-md-4">
      <b><label class="form-check-label">Email</label> </b>
      <div class="mb-4">
        <b-form-input
          v-model="objeto.email"
          id="email"
          placeholder="Email"
        ></b-form-input>
      </div>
    </div>
    <div class="col-sm-12 col-md-4">
      <b><label class="form-check-label">Contraseña</label> </b>
      <div class="mb-4">
        <b-form-input
          v-model="objeto.password"
          id="password"
          placeholder="Contraseña"
        ></b-form-input>
      </div>
    </div>
  </div>
  <!-- <div class="row mt-4">
    <div class="col-sm-12 col-md-4">
        <b><label class="form-check-label">Negocio</label></b>
        <div class="mb-4">
            <b-form-select
                class="form-select"
                v-model="objeto.id_negocio"
                size="lg"
            >
                <option 
                    v-for="neg in gerenteNegocio" 
                    :key="neg.nombre" 
                    :value="neg.id_negocio"
                    >{{neg.nombre}}
                </option>
            </b-form-select>
        </div>
    </div> 
    </div>-->
    </div>
</template>
